import SharedDropZoneDroparea from '../droparea';

export default class SharedDropZoneMobileDroparea extends SharedDropZoneDroparea {}
